import React, { useEffect, useState, Suspense } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import * as EnvConstants from '../src/Constants/EnvConstants';
import { QueryStringProvider } from './Contexts/QueryString';
import { VisitorParamsProvider } from './Contexts/VisitorParams';
import { queryString } from './Utility/QueryString';
import HomePage from './Components/Pages/HomePage';
import FbPixel from './Components/Pages/FbPixel';
// import './App.scss';
import { RedirectProvider } from './Contexts/RedirectContext';
import { ReferenceProvider } from './Contexts/ReferenceContext';
import HelmetBasedOnDomain from '../src/Components/Includes/Layouts/Common/HelmetBasedOnDomain';

const Questionnaire = React.lazy(
  () => import('./Components/Pages/Questionnaire')
);
const Followup = React.lazy(() => import('./Components/Pages/Splits/Followup'));
const Preview = React.lazy(() => import('./Components/Pages/Preview'));
const OpenBankingProceed = React.lazy(
  () => import('./Components/Pages/OpenBankingProceed')
);
const Unqualified = React.lazy(() => import('./Components/Pages/Unqualified'));
const Signature = React.lazy(() => import('./Components/Pages/Signature'));
const Thankyou = React.lazy(() => import('./Components/Pages/Thankyou'));
const IdUpload = React.lazy(() => import('./Components/Pages/IdUpload'));
const PreviewLoa = React.lazy(() => import('./Components/Pages/PreviewLoa'));
const NotFound = React.lazy(() => import('./Components/Pages/NotFound'));
const ADV_1 = React.lazy(() => import('./Components/Pages/Advertorials/ADV_1'));
const ADV1_Contact = React.lazy(
  () => import('./Components/Pages/Advertorials/ADV1_Contact')
);
const BudsRedirectPage = React.lazy(
  () => import('./Components/Pages/BudsRedirectPage')
);
const Proceed = React.lazy(() => import('./Components/Pages/Proceed'));
const PdfView = React.lazy(() => import('./Components/Pages/PdfView'));
const AdtopiaLoadDynamic = React.lazy(
  () => import('./Utility/AdtopiaLoadDynamic')
);
const Duplicate = React.lazy(() => import('./Components/Pages/Duplicate'));
const scheduledMaintenance = React.lazy(
  () => import('./Components/Pages/scheduledMaintenance')
);
// const Split_1 = React.lazy(() => import('./Components/Pages/Splits/Split_1'));
const RDFM_V1 = React.lazy(() => import('./Components/Pages/Splits/RDFM_V1'));
const RDFM_DF_V2 = React.lazy(
  () => import('./Components/Pages/Splits/RDFM_DF_V2')
);

const RDFM_V1_personal_details = React.lazy(
  () => import('./Components/Pages/RDFM_V1/PersonalDetails')
);
const RDFM_V1_OtpPage = React.lazy(
  () => import('./Components/Includes/Layouts/RDFM_V1/RDFM_V1_OtpPage')
);

const RDFM_V1_SiganturePage = React.lazy(
  () => import('./Components/Includes/Layouts/RDFM_V1/RDFM_V1_SiganturePage')
);
// const RDFM_DF_V2_signaturePage = React.lazy(
//   () => import('./Components/Includes/Layouts/RDFM_V1/RDFM_V1_SiganturePagev2')
// );
const RDFM_V1_LoaderAfterSignature = React.lazy(
  () =>
    import('./Components/Includes/Layouts/RDFM_V1/RDFM_V1_LoaderAfterSignature')
);
const IdUploadV1 = React.lazy(() => import('./Components/Pages/IdUploadV1'));
const ThankyouV1 = React.lazy(
  () => import('./Components/Includes/Layouts/RDFM_V1/ThankyouV1')
);
//lenders
const LendersV1 = React.lazy(() => import('./Components/Pages/LendersV1'));
//RDFM V1 Followup
const RDFM_V1_Followup = React.lazy(
  () => import('./Components/Pages/Followup/RDFM_V1/RDFM_V1_Followup')
);

const RDFM_V1_EditPage = React.lazy(
  () => import('./Components/Includes/Layouts/RDFM_V1/RDFM_V1_EditPage')
);

const KountLoader = React.lazy(() => import('./Components/Pages/KountLoader'));

const HighVolumeRequest = React.lazy(
  () => import('./Components/Pages/HighVolumeRequest')
);

const VerificationUnsuccessful = React.lazy(
  () => import('./Components/Pages/VerificationUnsuccessful')
);

const CreditCheckSuccess_flp = React.lazy(
  () => import('./Components/Pages/Followup/RDFM_V1/CreditCheckSuccess_flp')
);

const CreditCheckFail_flp = React.lazy(
  () => import('./Components/Pages/Followup/RDFM_V1/CreditCheckFail_flp')
);

const CreditCheckFail = React.lazy(
  () => import('./Components/Pages/CreditCheckFail')
);

const CreditCheckSuccess = React.lazy(
  () => import('./Components/Pages/CreditCheckSuccess')
);

const KountOtpPage = React.lazy(
  () => import('./Components/Includes/Layouts/RDFM_V1/KountOtpPage')
);

const App = () => {
  const [visitorParameters] = useState({ visitor_parameters: [], data: [] });
  const [redirectUrl] = useState({ redirectUrl: '' });

  // Loading component for Suspense fallback
  const LoadingFallback = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f8f9fa',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <img
          height="25"
          src="assets/RDFM_V1/img/blue-laoder.gif"
          alt="Loading..."
        />
        <p style={{ marginTop: '10px', color: '#666' }}>Loading...</p>
      </div>
    </div>
  );

  useEffect(() => {
    document.title = EnvConstants.AppTitle;
  }, []);
  const [referenceID, setReferenceID] = useState('');
  return (
    <>
      <HelmetBasedOnDomain />
      <VisitorParamsProvider>
        <QueryStringProvider value={{ queryString }}>
          <RedirectProvider value={{ redirectUrl }}>
            <ReferenceProvider value={{ referenceID, setReferenceID }}>
              <BrowserRouter>
                <Suspense fallback={<LoadingFallback />}>
                  <Route exact path="/" component={HomePage} />
                  {/* <Route exact path={['/Split_1']} component={Split_1} /> */}
                  <Route
                    exact
                    path={'/questionnaire'}
                    component={Questionnaire}
                  />
                  {/* <Route exact path={'/followup'} component={Followup} /> */}
                  <Route exact path={['/splash-page']} component={Preview} />
                  <Route exact path={'/proceed'} component={Proceed} />
                  <Route exact path={'/unqualified'} component={Unqualified} />
                  <Route exact path={'/signature'} component={Signature} />
                  <Route exact path={['/fbpixel']} component={FbPixel} />
                  <Route exact path={'/thankyou'} component={Thankyou} />
                  <Route
                    exact
                    path={'/buds-redirect-page'}
                    component={BudsRedirectPage}
                  />
                  <Route exact path={['/id-upload']} component={IdUpload} />
                  <Route exact path={['/preview']} component={PreviewLoa} />
                  <Route exact path={['/404']} component={NotFound} />
                  <Route exact path={['/ADV_1']} component={ADV_1} />
                  <Route
                    exact
                    path={['/ADV1/contact']}
                    component={ADV1_Contact}
                  />
                  <Route
                    exact
                    path={'/proceed-open-banking'}
                    component={OpenBankingProceed}
                  />
                  <Route
                    exact
                    path={['/:enviroment/:project_id/pdf/:doc_type/:filename']}
                    component={PdfView}
                  />
                  <Route
                    exact
                    path={['/google', '/testing']}
                    component={AdtopiaLoadDynamic}
                  />
                  <Route
                    exact
                    path={['/scheduled-maintenance']}
                    component={scheduledMaintenance}
                  />
                  <Route exact path={['/duplicate']} component={Duplicate} />

                  <Route exact path={['/RDFM_V1']} component={RDFM_V1} />
                  <Route exact path={['/RDFM_DF_V2']} component={RDFM_DF_V2} />
                  <Route
                    exact
                    path={['/rdfm_v1_personal_details']}
                    component={RDFM_V1_personal_details}
                  />

                  <Route
                    exact
                    path={['/rdfm-v1-otp']}
                    component={RDFM_V1_OtpPage}
                  />

                  <Route
                    exact
                    path={['/rdfm-v1-signature']}
                    component={RDFM_V1_SiganturePage}
                  />

                  {/* <Route
                    exact
                    path={['/rdfm-v2-signature']}
                    component={RDFM_DF_V2_signaturePage}
                  /> */}

                  <Route
                    exact
                    path={['/rdfm-v1-after-signature']}
                    component={RDFM_V1_LoaderAfterSignature}
                  />
                  <Route exact path={'/id-uploadV1'} component={IdUploadV1} />
                  <Route exact path={'/thankyouV1'} component={ThankyouV1} />
                  <Route exact path={'/v1/lenders'} component={LendersV1} />
                  <Route
                    exact
                    path={'/followup'}
                    component={RDFM_V1_Followup}
                  />
                  <Route
                    exact
                    path={['/rdfm-v1-edit-page']}
                    component={RDFM_V1_EditPage}
                  />
                  <Route
                    exact
                    path={['/kount-loader']}
                    component={KountLoader}
                  />
                  <Route
                    exact
                    path={['/high-volume-request']}
                    component={HighVolumeRequest}
                  />
                  <Route
                    exact
                    path={['/verification-unsuccessful']}
                    component={VerificationUnsuccessful}
                  />
                  <Route
                    exact
                    path={['/credit-check-success-flp']}
                    component={CreditCheckSuccess_flp}
                  />
                  <Route
                    exact
                    path={['/credit-check-failed-flp']}
                    component={CreditCheckFail_flp}
                  />
                  <Route
                    exact
                    path={['/credit-check-failed']}
                    component={CreditCheckFail}
                  />
                  <Route
                    exact
                    path={['/credit-check-success']}
                    component={CreditCheckSuccess}
                  />
                  <Route exact path={['/kount-otp']} component={KountOtpPage} />
                </Suspense>
              </BrowserRouter>
            </ReferenceProvider>
          </RedirectProvider>
        </QueryStringProvider>
      </VisitorParamsProvider>
    </>
  );
};

export default App;
